import Vue from 'vue'
import Router from 'vue-router'

import login from '../main/login.vue'

import main from '../main/main.vue' //主页
import homepage from '../pages/homepage.vue'  //首页
import settingUser from '../pages/settingUser.vue'//用户设置
import settingPartner from '../pages/settingPartner.vue'//角色设置
import editPwd from '../pages/editPwd.vue'//修改密码
import settingFactory from '../pages/settingFactory.vue'//工厂设置
// import settingStorage from '../pages/settingStorage.vue'//库房设置
import settingProduction from '../pages/settingProduction.vue'//生产线设置
import settingWork from '../pages/settingWork.vue'//班组设置
import settingWorkshop from '../pages/settingWorkshop.vue'//车间设置
import settingDealer from '../pages/settingDealer.vue'//经销商设置
import settingAdd from '../pages/settingAdd.vue'//经销批量增加
import settingPacking from '../pages/settingPacking.vue'//包装比例设置
import settingProduct from '../pages/settingProduct.vue'//产品设置
import systemLog from '../pages/systemLog.vue'//系统日志
import unusualLog from '../pages/unusualLog.vue'//异常日志
import enterpriseFwQuery from '../pages/enterpriseFwQuery.vue'//企业防伪查询
import antiFakeTotalStatics from '../pages/antiFakeTotalStatics.vue'//原始清单查询
import fwtj from '../pages/fwtj.vue'//重复查询情况汇总
import antiFakeSingleStatics from '../pages/antiFakeSingleStatics.vue'//单码查询情况汇总
import antiFakeUnNomalStatics from '../pages/antiFakeUnNomalStatics.vue'//无经销商产品查询
import outListQry from '../pages/outListQry.vue'//出库单查询
import outListQryStatistics from '../pages/outListQryStatistics.vue'//出库单统计
import outStoreSeqCode from '../pages/outStoreSeqCode.vue'//顺序码出库
import billHandleList from '../pages/billHandleList.vue'//顺序码单据处理查询
import codeRelationQuery from '../pages/codeRelationQuery.vue'//数码关系查询
import singCodeTrace from '../pages/singCodeTrace.vue'//数码详细查询
import scurryGoodsQry from '../pages/scurryGoodsQry.vue'//窜货查询
import scurryGoodsTJ from '../pages/scurryGoodsTJ.vue'//窜货统计
import frmscurryop from '../pages/frmscurryop.vue'//稽查员管理
import scurryMng from '../pages/scurryMng.vue'//稽查员工作查询
import parameter from '../pages/parameter.vue'//权限设置
import moduleSettings from '../pages/moduleSettings.vue'//系统模块设置


import productStorage from '../pages/productStorage.vue'//产品入库
import productWarehouseOut from '../pages/productWarehouseOut.vue'//产品出库
import dealerStorage from '../pages/dealerStorage.vue'//经销商入库
import dealerWarehouseOut from '../pages/dealerWarehouseOut.vue'//经销商出库
import enterpriseStorage from '../pages/enterpriseStorage.vue'//企业入库
import enterpriseWarehouseOut from '../pages/enterpriseWarehouseOut.vue'//企业出库

import manufactureData from '../pages/manufactureData.vue'//生产数据
import intoData from '../pages/intoData.vue'//入库报表
import outData from '../pages/outData.vue'//入库报表
import returnData from '../pages/returnData.vue'//退货报表
import cargoData from '../pages/cargoData.vue'//调货报表
import inListQry from '../pages/inListQry.vue'//入库单查询
import storeMngStatistics from '../pages/storeMngStatistics.vue'//库存统计
import overview from '../pages/overview.vue' //数据概览
import sell from '../pages/sell.vue' //销售数据趋势图
import dealer from '../pages/dealer.vue' //经销商销售数据排行
import fwTrend from '../pages/fwTrend.vue' //防伪数据趋势图
import fwArea from '../pages/fwArea.vue' //防伪数据热力图
import fwAmount from '../pages/fwAmount.vue' //防伪数据次数-来源分布
import fwPeriod from '../pages/fwPeriod.vue' //防伪查询热段图
import fcHeating from '../pages/fcHeating.vue' //疑似窜货热力图
import fcTrend from '../pages/fcTrend.vue' //疑似窜货趋势图
import fcDealer from '../pages/fcDealer.vue' //疑似窜货经销商排行
import fcCity from '../pages/fcCity.vue' //疑似窜货城市排行
import fcCargo from '../pages/fcCargo.vue' //疑似窜货产品排行
import anomalyData from '../pages/anomalyData.vue' //异常情况分析

import InStoreSequenceCode from '../pages/InStoreSequenceCode.vue' //顺序码入库
import InListQS from '../pages/InListQS.vue' //入库单统计
import inListQryStatistics from '../pages/inListQryStatistics.vue' //生产统计
import BindCodeInfo from '../pages/BindCodeInfo.vue' //顺序码信息绑定
import BindCodeList from '../pages/BindCodeList.vue' //顺序码信息绑定查询
import wlBillsFileQry from '../pages/wlBillsFileQry.vue' //物流操作文件查询
import PackagingRelationFileQry from '../pages/PackagingRelationFileQry.vue' //包装关系文件查询
import MutualQuery from '../pages/MutualQuery.vue' //物流码防伪码互查
import PularCodeTrace from '../pages/PularCodeTrace.vue' //数码批量查询下载
import CodeReplace from '../pages/CodeReplace.vue' //数码替换
import CreateInBillList from '../pages/CreateInBillList.vue' //创建入库单
import CreateOutBillList from '../pages/CreateOutBillList.vue' //创建出库单
import CreateTaskBillList from '../pages/CreateTaskBillList.vue' //创建任务单
import EnDealerInStoreCount from '../pages/EnDealerInStoreCount.vue' //经销商入库统计
import DeOutSummary from '../pages/DeOutSummary.vue' //经销商出库统计
import EnDealerStock from '../pages/EnDealerStock.vue' //经销商库存查询
import EnDealerMngALL from '../pages/EnDealerMngALL.vue' //经销商库存查询
import DealerInStoreQuery from '../pages/DealerInStoreQuery.vue' //经销商入库查询
import DealerOutStoreQuery from '../pages/DealerOutStoreQuery.vue' //经销商出库查询
import OutListDetails from '../pages/OutListDetails.vue' //出库单据详情
import inListDetails from '../pages/inListDetails.vue' //入库单据详情

import DealerMng from '../pages/DealerMng.vue' //下级经销商设置
import DealerUserList from '../pages/DealerUserList.vue' //下级经销商用户设置
import ChangePwd from '../pages/ChangePwd.vue' //经销商密码修改

Vue.use(Router)

export default new Router({
  routes: [ {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      name: 'main',
      path: '/main',
      component: main,
      children: [
        {
          path: 'homepage',
          name: 'homepage',
          component: homepage
        },{
          path: 'settingUser',
          name: 'settingUser',
          component: settingUser
        },{
          path: 'settingPartner',
          name: 'settingPartner',
          component: settingPartner
        },{
          path: 'editPwd',
          name: 'editPwd',
          component: editPwd
        },{
          path: 'settingFactory',
          name: 'settingFactory',
          component: settingFactory
        },
        // {
        //   path: 'settingStorage',
        //   name: 'settingStorage',
        //   component: settingStorage
        // },
        {
          path: 'settingProduction',
          name: 'settingProduction',
          component: settingProduction
        },{
          path: 'settingWork',
          name: 'settingWork',
          component: settingWork
        },{
          path: 'settingWorkshop',
          name: 'settingWorkshop',
          component: settingWorkshop
        },{
          path: 'settingDealer',
          name: 'settingDealer',
          component: settingDealer
        },{
          path: 'settingAdd',
          name: 'settingAdd',
          component: settingAdd
        },{
          path: 'settingPacking',
          name: 'settingPacking',
          component: settingPacking
        },{
          path: 'settingProduct',
          name: 'settingProduct',
          component: settingProduct
        },{
          path: 'systemLog',
          name: 'systemLog',
          component: systemLog
        },{
          path: 'unusualLog',
          name: 'unusualLog',
          component: unusualLog
        },{
          path: 'enterpriseFwQuery',
          name: 'enterpriseFwQuery',
          component: enterpriseFwQuery
        },{
          path: 'antiFakeTotalStatics',
          name: 'antiFakeTotalStatics',
          component: antiFakeTotalStatics
        },{
          path: 'fwtj',
          name: 'fwtj',
          component: fwtj
        },{
          path: 'antiFakeSingleStatics',
          name: 'antiFakeSingleStatics',
          component: antiFakeSingleStatics
        },{
          path: 'antiFakeUnNomalStatics',
          name: 'antiFakeUnNomalStatics',
          component: antiFakeUnNomalStatics
        },{
          path: 'outListQry',
          name: 'outListQry',
          component: outListQry
        },{
          path: 'outListQryStatistics',
          name: 'outListQryStatistics',
          component: outListQryStatistics
        },{
          path: 'outStoreSeqCode',
          name: 'outStoreSeqCode',
          component: outStoreSeqCode
        },{
          path: 'billHandleList',
          name: 'billHandleList',
          component: billHandleList
        },{
          path: 'codeRelationQuery',
          name: 'codeRelationQuery',
          component: codeRelationQuery
        },{
          path: 'singCodeTrace',
          name: 'singCodeTrace',
          component: singCodeTrace
        },{
          path: 'scurryGoodsQry',
          name: 'scurryGoodsQry',
          component: scurryGoodsQry
        },{
          path: 'scurryGoodsTJ',
          name: 'scurryGoodsTJ',
          component: scurryGoodsTJ
        },{
          path: 'frmscurryop',
          name: 'frmscurryop',
          component: frmscurryop
        },{
          path: 'scurryMng',
          name: 'scurryMng',
          component: scurryMng
        },{
          path: 'parameter',
          name: 'parameter',
          component: parameter
        },{
          path: 'moduleSettings',
          name: 'moduleSettings',
          component: moduleSettings
        },{
          path: 'productStorage',
          name: 'productStorage',
          component: productStorage
        },{
          path: 'productWarehouseOut',
          name: 'productWarehouseOut',
          component: productWarehouseOut
        },{
          path: 'dealerWarehouseOut',
          name: 'dealerWarehouseOut',
          component: dealerWarehouseOut
        },{
          path: 'dealerStorage',
          name: 'dealerStorage',
          component: dealerStorage
        },{
          path: 'enterpriseStorage',
          name: 'enterpriseStorage',
          component: enterpriseStorage
        },{
          path: 'enterpriseWarehouseOut',
          name: 'enterpriseWarehouseOut',
          component: enterpriseWarehouseOut
        },{
          path: 'manufactureData',
          name: 'manufactureData',
          component: manufactureData
        },{
          path: 'intoData',
          name: 'intoData',
          component: intoData
        },{
          path: 'outData',
          name: 'outData',
          component: outData
        },{
          path: 'returnData',
          name: 'returnData',
          component: returnData
        },{
          path: 'cargoData',
          name: 'cargoData',
          component: cargoData
        },{
          path: 'inListQry',
          name: 'inListQry',
          component: inListQry
        },{
          path: 'storeMngStatistics',
          name: 'storeMngStatistics',
          component: storeMngStatistics
        },{
          path: 'overview',
          name: 'overview',
          component: overview
        },{
          path: 'sell',
          name: 'sell',
          component: sell
        },{
          path: 'dealer',
          name: 'dealer',
          component: dealer
        },{
          path: 'fwTrend',
          name: 'fwTrend',
          component: fwTrend
        },{
          path: 'fwArea',
          name: 'fwArea',
          component: fwArea
        },{
          path: 'fwAmount',
          name: 'fwAmount',
          component: fwAmount
        },{
          path: 'fwPeriod',
          name: 'fwPeriod',
          component: fwPeriod
        },{
          path: 'fcHeating',
          name: 'fcHeating',
          component: fcHeating
        },{
          path: 'fcTrend',
          name: 'fcTrend',
          component: fcTrend
        },{
          path: 'fcDealer',
          name: 'fcDealer',
          component: fcDealer
        },{
          path: 'fcCity',
          name: 'fcCity',
          component: fcCity
        },{
          path: 'fcCargo',
          name: 'fcCargo',
          component: fcCargo
        },{
          path: 'anomalyData',
          name: 'anomalyData',
          component: anomalyData
        },{
          path: 'InStoreSequenceCode',
          name: 'InStoreSequenceCode',
          component: InStoreSequenceCode
        },{
          path: 'InListQS',
          name: 'InListQS',
          component: InListQS
        },{
          path: 'inListQryStatistics',
          name: 'inListQryStatistics',
          component: inListQryStatistics
        },{
          path: 'BindCodeInfo',
          name: 'BindCodeInfo',
          component: BindCodeInfo
        },{
          path: 'BindCodeList',
          name: 'BindCodeList',
          component: BindCodeList
        },{
          path: 'wlBillsFileQry',
          name: 'wlBillsFileQry',
          component: wlBillsFileQry
        },{
          path: 'PackagingRelationFileQry',
          name: 'PackagingRelationFileQry',
          component: PackagingRelationFileQry
        },{
          path: 'MutualQuery',
          name: 'MutualQuery',
          component: MutualQuery
        },{
          path: 'PularCodeTrace',
          name: 'PularCodeTrace',
          component: PularCodeTrace
        },{
          path: 'CodeReplace',
          name: 'CodeReplace',
          component: CodeReplace
        },{
          path: 'CreateInBillList',
          name: 'CreateInBillList',
          component: CreateInBillList
        },{
          path: 'CreateOutBillList',
          name: 'CreateOutBillList',
          component: CreateOutBillList
        },{
          path: 'CreateTaskBillList',
          name: 'CreateTaskBillList',
          component: CreateTaskBillList
        },{
          path: 'EnDealerInStoreCount',
          name: 'EnDealerInStoreCount',
          component: EnDealerInStoreCount
        },{
          path: 'DeOutSummary',
          name: 'DeOutSummary',
          component: DeOutSummary
        },{
          path: 'EnDealerStock',
          name: 'EnDealerStock',
          component: EnDealerStock
        },{
          path: 'EnDealerMngALL',
          name: 'EnDealerMngALL',
          component: EnDealerMngALL
        },{
          path: 'DealerInStoreQuery',
          name: 'DealerInStoreQuery',
          component: DealerInStoreQuery
        },{
          path: 'DealerOutStoreQuery',
          name: 'DealerOutStoreQuery',
          component: DealerOutStoreQuery
        },{
          path: 'DealerMng',
          name: 'DealerMng',
          component: DealerMng
        },{
          path: 'OutListDetails',
          name: 'OutListDetails',
          component: OutListDetails
        },{
          path: 'inListDetails',
          name: 'inListDetails',
          component: inListDetails
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js